module.exports = __webpack_public_path__ + "static/media/mastercard.9bbf04fa.svg";